import { useQuery } from "react-query";
import { peerGroupQueryKeys } from "queries/constants";
import { QueryOptions } from "queries/queries";
import { useToast } from "components/common/ui/toast/useToast";
import { fetchMeetingsByPeergroupId } from "api/PeerGroupApi";

export const usePeerGroupMeetings = (
  peergroupId: string,
  options?: QueryOptions
) => {
  const { addErrorToast } = useToast();
  return useQuery(
    peerGroupQueryKeys.meetings(peergroupId),
    () => fetchMeetingsByPeergroupId(peergroupId),
    {
      onError: (e) =>
        addErrorToast(e, "Unable to load peer group meetings", {
          id: peerGroupQueryKeys.meetings(peergroupId).join("::"),
        }),
      staleTime: 60 * 1000,
      ...options,
    }
  );
};
